import { Fragment, useContext } from "react"
import { Create } from "./components/Item/components"
import { BaseTable, Input } from "../../../../../../components"
import { dataAccountLinkSales } from "../../utils/vars"
import { LinkAccountContext } from "pages/Setup/contexts"

export function ChildItem() {

     const { data, refetch } = useContext(LinkAccountContext)

    const coaData: any = {};
    data.forEach(item => {
        coaData[item.linked_account_code] = {
            coa_code: item.coa_code || '',
            coa_name: item.coa_name || '',
            coa_group_code: item.group_coa_code || ''
        }
    })

    return (
        <Fragment>
            <div className="border">
                {dataAccountLinkSales?.map((data, key) => (
                    <div key={key}>
                        <div className="border p-4">
                            <span className="font-bold">{data.Header}</span>
                        </div>
                        <div>
                            <div className="p-4">
                                <BaseTable>
                                    <thead>
                                        <tr>
                                            <th className="border">CODE</th>
                                            <th className="border" colSpan={2}>DESCRIPTION</th>
                                            <th className="border">NUMBER</th>
                                            <th className="border">COA NAME</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data?.LinkAccount?.map((item, index) => (
                                            <tr key={index}>
                                                <td className="border w-[100px]">{item?.linked_account_code}</td>
                                                <td className="border w-[300px]">{item?.description}</td>
                                                <td className="border text-center w-[100px]">
                                                    <Create dataItem={item} coaType={item.account_coa} refetch={refetch} />
                                                </td>
                                                <td className="border w-[200px]">{(coaData[item.linked_account_code]?.coa_group_code) ? `${coaData[item.linked_account_code]?.coa_code}` : ''}</td>
                                                <td className="border w-[200px]">{coaData[item.linked_account_code]?.coa_name}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </BaseTable>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <div className="grid grid-cols-2 mt-6 mb-3">
                <div className="font-bold my-auto">
                    SALES INVOICE FOOTER INFORMATION
                </div>
                <div className="my-auto">
                    <Input inputClass="h-[50px]" onChange={(e) => e.target.value} />
                </div>
            </div>
        </Fragment>
    )
}